import axiosInstance from "./baseUrl";

export const loginService = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  const response = await axiosInstance.post("/v1/auth/login", {
    email,
    password,
  });
  return response.data;
};

export const signupService = async (signUpData: any) => {
  const response = await axiosInstance.post(
    "/v1/auth/create_admin",
    signUpData
  );
  return response.data;
};

export const refreshTokenService = async (refreshToken: string, userId: string) => {
  const response = await axiosInstance.post("/v1/auth/refresh_token", {
    oldRefreshToken: refreshToken,
    userId,
  });
  return response.data;
};
